import { Trans, t } from '@lingui/macro';
import { AvatarWithLabel, Button, Dialog, DialogContent, DialogFooter, DialogHeader, } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Markdown } from '../../../../Markdown';
export function ReferenceDialog(props) {
    const { onClose, content } = props;
    return (<Dialog>
      <DialogHeader media={<AvatarWithLabel truncate title={t({
                message: 'Playbook reference',
                comment: 'Plai Review - Issue Item - Playbook Reference - dialog title',
            })} shape="circle">
            <Falcon icon="book"/>
          </AvatarWithLabel>}/>
      <DialogContent>
        <Markdown contents={content}/>
      </DialogContent>
      <DialogFooter>
        <Button onClick={onClose}>
          <Trans comment="Plai Review - Issue Item - Playbook Reference - dialog button label">
            Got it
          </Trans>
        </Button>
      </DialogFooter>
    </Dialog>);
}
